import React from 'react';
import PropTypes from 'prop-types';

function IconPrivate({ color = '#88898B', size = 16, className }) {
  return (
    <svg width={size} height={size} className={className} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8.75 3.75C12.25 4.25 14.25 8 14.25 8C14.25 8 13.75 9.25 12.75 10.25M10.25 11.75C4.25 13.75 1.75 8 1.75 8C1.75 8 2.25 6.25 4.75 4.75" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M8.62501 9.083C8.35419 9.2393 8.03461 9.28842 7.72934 9.22067C7.42407 9.15291 7.15529 8.97321 6.97601 8.717C6.79649 8.4609 6.71949 8.1468 6.76022 7.83671C6.80095 7.52662 6.95644 7.24306 7.19601 7.042L8.00001 8L8.62501 9.083Z" fill={color} stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M3.75 1.75L12.25 14.25" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}

IconPrivate.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  className: PropTypes.string
}

export default IconPrivate;
